import PropTypes from 'prop-types';
import {useAuthContext} from "../providers/AuthProvider.jsx";
import {Navigate, useLocation} from "react-router-dom";

const RequireAuth = ({children}) => {

    const authContext = useAuthContext()
    const location = useLocation()
    if (authContext.isLoading) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <span className="loading loading-spinner loading-lg text-primary" />
            </div>
        );
    }

    if(!authContext.isAuth)
        return (
            <Navigate
                to='/login'
                replace
                state={{ from: `${location.pathname}${location.search}${location.hash}` }}
            />
        )


    return children
}

RequireAuth.propTypes = {
    children: PropTypes.node.isRequired,
};

export default RequireAuth
